import PathWrapper from "core/PathWrapper";

export const mugarDonatePath = new PathWrapper('mugarstatue')